<template>
    <div>
        <label for="provincias">{{ $t('formularios.provincia') }}</label>
        <ValidationProvider name="provincias" id="provincias" rules="required" v-slot="{ errors }">
            <multiselect
                :disabled="desactivar"
                v-model="selected"
                :placeholder="$t('formularios.provincia')"
                label="nombre"
                track-by="id"
                :options="provincias"
                :multiple="false"
                v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
            />
            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
        </ValidationProvider>
    </div>
</template>

<script>
    export default {
        props: {
            provincia: {
                type: [Object, String],
                default: null
            },
            errors: {
                type: Array,
                default: () => ([])
            },
            pais: {
                type: Number,
                default: 68 // Default to Spain
            },
            desactivar: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                provincias: [],
                selected: null,
                provinciaEncontrada: null 
            }
        },
        watch: {
            pais() {
                if(this.pais) this.getProvincias();
            },
            provincia: {
                handler(newProvincia) {
                    if (newProvincia && this.provincias.length > 0) {
                        this.syncSelectedProvincia(newProvincia);
                    }
                },
                immediate: true
            },
            provincias: {
                handler(newProvincias) {
                    if (this.provincia && newProvincias.length > 0) {
                        this.syncSelectedProvincia(this.provincia);
                    }
                }
            }
        },
        created() {
            this.getProvincias();
        },
        methods: {
            getProvincias() {
                const data = {
                    filters: {
                        pais_id: this.pais,
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('select.provincias'), data).then(res => {
                    this.provincias = res.data.data;
                    if (this.provincia) {
                        this.syncSelectedProvincia(this.provincia);
                    }

                    this.$emit('provinciasCargadas', this.provincias);
                });
            },
            syncSelectedProvincia(provincia) {
                if (!provincia || !this.provincias.length) return;
                
                const found = this.provincias.find(p => {
                    if (p.id && provincia.id) {
                        return p.id === provincia.id;
                    }

                    if (p.nombre && provincia.nombre) {
                        return p.nombre === provincia.nombre;
                    }

                    if (typeof provincia === 'string') {
                        return p.nombre === provincia;
                    }
                    return false;
                });
                
                if (found) {
                    this.selected = found;
                    this.provinciaEncontrada = found; 

                    this.$emit('selected', found);
                }
            }
        }
    }
</script>
